import request from '@/utils/request'

let Insurance_companyApi = {

  /*保险公司列表*/
  list(data) {
    return request._post('/shop/plus.insurance_company.Index/index', data);
},
/*添加保险公司*/
add(data) {
    return request._post('/shop/plus.insurance_company.Index/add', data);
},
/*修改保险公司*/
edit(data) {
    return request._post('/shop/plus.insurance_company.Index/edit', data);
},
/*删除保险公司*/
del(data) {
    return request._post('/shop/plus.insurance_company.Index/del', data);
},
/*保险公司详情*/
detail(data) {
  return request._post('/shop/plus.insurance_company.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.insurance_company.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.insurance_company.Setting/getSetting', data, errorback);
    },
}
export default Insurance_companyApi;



// WEBPACK FOOTER //
// ./src/api/insurance_company.js